import React, { useState, Fragment, useRef } from "react";
import { NavLink } from "react-router-dom";
import Footer from "../../component/Other/Footer";
import Navbar from "../../component/Other/Navbar";
import Discover from "../../component/Page/Discover";
import Price from "../../component/Page/Price";
import Program from "../../component/Page/Program";
import Testimonial from "../../component/Page/Testimonial";

const Index = (props) => {
  return (
    <Fragment>
      <div className="overflow-hidden">

        <div className="position-relative bg__blue">
          <Navbar />

          <section className="position-relative">
            <div className="container position-relative">
              <img src="./../images/Group 1.png" className="images__head-hero z-2 d-none d-lg-block" alt="" />
              <div className="row mb-5 position-relative">
                <div className="col-lg-6">
                  <h1 className="color__white font__size--68 text__70-1024 text__68-md text__70-sm text__70-xxs normal">
                    <span className="d-block">Stop <span className="medium">Trying</span></span>
                    <span className="d-block">Start <span className="medium">Transforming</span></span>
                  </h1>
                  <ul className="list-unstyled normal font__size--16 text__16-1024 color__gray-1 mb-5">
                    <li className="mb-2">Master’s degree holder in Specialized Nutrition from Cairo University</li>
                    <li className="mb-2">Internationally certified Nutritionist by Precision Nutrition (Canada)</li>
                    <li className="mb-2">
                      Certified Clinical Nutritionist from AACME
                    </li>
                    <li className="mb-2">Certified from Zewail City in Clinical Nutrition and Food Safety.</li>
                    <li className="mb-2">Certified by the ISSA (USA) as a Personal Trainer</li>
                    <li>Hold further credentials in Obesity, Underweight, and Sports Nutrition.</li>
                  </ul>
                  <NavLink
                    to="/contact" className="medium font__size--16 text__16-1024 btn btn__purple color__white shadow rounded__24 color__white mb__5">Let's Talk</NavLink>

                  <p className="medium font__size--14 text__14-1042 color__white">Supported by:</p>
                  <div className="wrapper__brand d-flex align-items-center opacity__6">
                    <img src="./../images/ad (1).png" alt="" />
                    <img src="./../images/ad (2).png" alt="" />
                    <img src="./../images/ad (3).png" alt="" />
                    <img src="./../images/ad (4).png" alt="" />
                    <img src="./../images/ad (5).png" alt="" />
                  </div>
                </div>
              </div>

              <div className="row position-relative z-3">
              <div className="col-lg-3 mt-4 my-lg-auto">
                  <h3 className="medium font__size--40 text__40-1024 text__40-md text__40-mm color__white">How is the process simple and easy?</h3>
                  <p className="normal font__size--14 text__14-1042 color__gray-1">Are you ready to begin your journey and experience the change? 
                  Start now and let your body tell you the difference.</p>
                </div>
                <div className="col-lg-9">
                  <Program />
                </div>
              
              </div>
            </div>
          </section>
        </div>


        <section>
          <div className="container">
            <h2 className="medium font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx text-center mb-5">We offer something for <br /> everybody</h2>

            <div className="row">
              <div className="col-lg-6 mb-4 my-lg-auto">
                <div className="wrapper__side-content-body">
                  <img src="./../images/fitness-biceps.png" className="mb-3" alt="" />
                  <h3 className="medium font__size--32 text__32-1024 text__32-xs mb-4">
                    <span className="d-block">Lose Weight — The Healthy Way</span>
                    <span className="d-block">Not the Hard Way</span>
                  </h3>

                  <ul className="list__data-detail medium font__size--18 text__18-1024">
                    <li>
                      <div className="d-flex">
                        <img src="./../images/Icon.png" className="object-fit-content" alt="" />
                        <span className="ml-2">Personalized meal plans that fit your lifestyle, not restrict it.</span>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <img src="./../images/Icon.png" className="object-fit-content" alt="" />
                        <span className="ml-2">Science-backed strategies to boost your metabolism naturally.</span>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <img src="./../images/Icon.png" className="object-fit-content" alt="" />
                        <span className="ml-2">Steady, lasting results with full support every step of the way.</span>
                      </div>
                    </li>
                  </ul>

                  <div className="d-block">
                    <img src="./../images/Line.png" className="my-4" alt="" />
                  </div>

                  <NavLink
                    to="/membership" className="medium font__size--16 text__16-1024 btn btn__purple shadow rounded__50 color__white">Join Now</NavLink>
                </div>
              </div>
              <div className="col-lg-6 my-lg-auto">
                <img src="./../images/Image (5).png" className="images__side-body" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 mb-4 my-lg-auto">
                <img src="./../images/sdsad.png" className="images__side-body" alt="" />
              </div>
              <div className="col-lg-6 my-lg-auto">
                <div className="wrapper__side-content-body">
                  <img src="./../images/heart-checkmark.png" className="mb-3" alt="" />
                  <h3 className="medium font__size--32 text__32-1024 text__32-xs mb-4">Gain Weight — Smart, Strong, and Sustainably</h3>

                  <ul className="list__data-detail medium font__size--18 text__18-1024">
                    <li>
                      <div className="d-flex">
                        <img src="./../images/Icon.png" className="object-fit-content" alt="" />
                        <span className="ml-2">Balanced nutrition plans tailored to your body goals.</span>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <img src="./../images/Icon.png" className="object-fit-content" alt="" />
                        <span className="ml-2"> Healthy calorie boosting without junk or bloating.</span>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <img src="./../images/Icon.png" className="object-fit-content" alt="" />
                        <span className="ml-2">Powerlifting</span>
                      </div>
                    </li>
                  </ul>

                  <div className="d-block">
                    <img src="./../images/Line.png" className="my-4" alt="" />
                  </div>

                  <NavLink
                    to="/membership" className="medium font__size--16 text__16-1024 btn btn__purple shadow rounded__50 color__white">Join Now</NavLink>
                </div>
              </div>

            </div>
          </div>
        </section>

        <Price />

        <Testimonial />

        <Discover />

        <Footer />

      </div >
    </Fragment >
  );
};

export default Index;
